import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { departmentsOptionsConstant, currencyOptionsConstant, organisationType, organisationSubType } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { CommonService } from '../../../services/common.service';
import { MessageBoxComponent } from '../../../common/message-box/message-box.component';
import { SuccessBanertemplateComponent } from 'src/app/common/success-banertemplate/success-banertemplate.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product-network-locations-view-modal',
  templateUrl: './product-network-locations-view-modal.component.html',
  styleUrls: ['./product-network-locations-view-modal.component.scss']
})
export class ProductNetworkLocationsViewModalComponent implements OnInit {

  formFields;
  departments = departmentsOptionsConstant;
  organisationType: any[];
  organisationSubType:any[];
  studyTeamOrganizationForm: UntypedFormGroup;
  ApplicationID: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
@Input() public Content: any;
  currencyOptions = currencyOptionsConstant;
  constructor(
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    public commonService: CommonService,

  ) {
  }

  ngOnInit() {
    this.studyTeamOrganizationForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      ACTIVECHECK:new UntypedFormControl(true),
      TYPE: new UntypedFormControl("-1"),
      SUB_TYPE: new UntypedFormControl("-1"),
      ADDRESS: new UntypedFormControl(""),
    });
    this.getMasterData();
    if (this.Content.heading == "Edit" || this.Content.heading == "View") {
      this.getOrganizationData();
    }
    if (this.Content.heading === 'Add') { //Add mode 
      this.Content.content.id = this.commonService.getUniqueId();
    }
  }
  getMasterData() {
    this.organisationType=[];
    this.organisationSubType = [];
    this.summaryService.getSummaryData('api/ProductNetworkLocations/GetMasterData?RecordID=' + this.Content.content.id).subscribe(summary => {
      this.organisationType = summary["MasterData1"];
      this.organisationType=[{label:"Select",value:"-1", checked: true}].concat(this.organisationType);
      this.organisationSubType = summary["MasterData2"];
      this.organisationSubType=[{label:"Select",value:"-1", checked: true}].concat(this.organisationSubType);
      });
  }
  getOrganizationData() {
    this.summaryService.getSummaryData('api/ProductNetworkLocations/Edit?RecordID=' + this.Content.content.id).subscribe(summary => {
      this.studyTeamOrganizationForm.patchValue({
        ID: summary["ID"],
        NAME: summary["NAME"],
        ACTIVECHECK: summary["RECORD_STATE"] == 1 ? true : false,
        TYPE: summary["TYPE"],
        SUB_TYPE: summary["SUB_TYPE"],
        ADDRESS: summary["ADDRESS"],
      });
      if (this.Content.heading == "View") {
        this.studyTeamOrganizationForm.disable();
      }

    });
  }
 
  SaveISTOrganization() {
    if (this.validateControls()) {
      var formData = this.studyTeamOrganizationForm.value;
      formData.NAME=formData.NAME==null?null:formData.NAME==undefined?undefined:formData.NAME.trim();
      formData.RECORD_STATE = this.studyTeamOrganizationForm.controls["ACTIVECHECK"].value ? 1 : 0;
      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert('api/ProductNetworkLocations/Insert', formData).subscribe(summary => {
            if(summary["Status"]===0){
            this.commonService.SuccessBanner(summary.Message);
            
            this.modalRef.close();
            }
            else{
              this.commonService.ValidationBanner(summary.Message);
              }
        });
      }
      else {
        this.summaryService.Insert('api/ProductNetworkLocations/Update', formData).subscribe(summary => {
            if(summary["Status"]===0)
            {
              this.commonService.SuccessBanner(summary.Message);
              
            this.modalRef.close();
            }
            else{
              this.commonService.ValidationBanner(summary.Message);
            }
          });
      }
    }
  }

  CancelPopUp() {
    
    this.modalRef.close();
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.studyTeamOrganizationForm.value;
    if (formData.NAME === null || formData.NAME === ""||formData.NAME=== undefined) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Product Network Location<br/>";
      isValid = false;
    }
    else if((formData.NAME !=null && formData.NAME != undefined)&&(formData.NAME.trim()=="")){
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Product Network Location<br/>";
      isValid = false;
    }
    else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.ADDRESS === null || formData.ADDRESS === "") {
      $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
      $("#ADDRESS").removeClass("ng-untouched ng-valid");
      message += "Please enter Address<br/>";
      isValid = false;
    } else {
      $("#ADDRESS").addClass("ng-untouched ng-valid");
      $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
    this.commonService.ValidationBanner(message);
    return isValid;
  }

}
